module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1n3r6n-1141ba26d7d8df68750102be35630b40.svg";